import Reveal from "@/components/Reveal";

export default function Presentazione() {
  return (
    <section id="presentazione" data-testid="presentazione-section" className="bg-linen px-6 py-28 text-midnight md:py-40 lg:px-10">
      <div className="mx-auto grid max-w-7xl items-center gap-16 lg:grid-cols-2 lg:gap-24">
        <div>
          <Reveal>
            <p className="mb-6 flex items-center gap-4 text-xs font-medium uppercase tracking-[0.35em] text-sand">
              <span className="h-px w-10 bg-sand/70" /> Presentazione
            </p>
            <h2 className="font-serif text-4xl leading-tight tracking-tight sm:text-5xl md:text-6xl">
              Location per <span className="italic text-sand">eventi</span>
              <br />a Roma.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 max-w-lg text-base font-light leading-relaxed text-midnight/70 md:text-lg">
              Nel cuore della Tuscolana, Club Star Eventi è un locale privato
              pensato per chi vuole festeggiare in un ambiente accogliente,
              curato e interamente allestito per il vostro evento. Da oltre
              dieci anni accompagniamo i nostri ospiti nell'organizzazione di
              feste ed eventi privati, mettendo l'esperienza al servizio dei
              vostri ricordi.
            </p>
            <p className="mt-5 max-w-lg text-base font-light leading-relaxed text-midnight/70 md:text-lg">
              Gli ampi e luminosi spazi sanno dare un tocco moderno agli
              ambienti, rendendoli versatili e adatti a molteplici tipologie di
              allestimento: ogni evento trova qui la sua scenografia ideale.
            </p>
            <p className="mt-5 max-w-lg text-base font-light leading-relaxed text-midnight/70 md:text-lg">
              La sala al piano di sopra rende la location ancora più speciale:
              elegante e raffinata, accoglie la cena in un'atmosfera raccolta
              e luminosa, perfetta per i momenti da ricordare.
            </p>
            <p className="mt-5 max-w-lg text-base font-light leading-relaxed text-midnight/70 md:text-lg">
              Il nostro punto di forza è la cura dei dettagli: ogni angolo è
              studiato per creare un'atmosfera unica, dove voi e i vostri
              ospiti vi sentirete protagonisti dal primo all'ultimo momento.
            </p>
          </Reveal>

        </div>

        <div className="relative pb-16 pr-6 md:pr-12">
          <Reveal delay={0.1}>
            <div className="group relative ml-auto aspect-[4/5] w-4/5 overflow-hidden" data-testid="presentazione-image-festa">
              <img
                src="/festa-club.webp"
                alt="Festa di diciottesimo al Club: la festeggiata sul trono con il suo bouquet"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
            </div>
          </Reveal>
          <Reveal delay={0.3} className="absolute bottom-0 left-0 w-3/5">
            <div className="group relative aspect-square overflow-hidden border-8 border-linen shadow-2xl" data-testid="presentazione-image-luci">
              <img
                src="/parete-luci.webp"
                alt="La parete in pietra del Club illuminata da luci colorate"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
